<template>
    <div class="locale-font">
        <div class="breadcrumb-container">
            <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
        </div>
        <div class="header-container">
            <h1 class="head-line-page">
                {{ breadcrumbsItem[1].text }}
            </h1>
            <div>
                <v-btn
                    class="mr-4"
                    color="primary"
                    outlined
                    @click="backToCompanyUserList()"
                >
                    {{ $vuetify.lang.t('$vuetify.userForm.cancel') }}
                </v-btn>

                <v-btn
                    color="primary"
                    @click="submit()"
                >
                    {{ $vuetify.lang.t('$vuetify.userForm.save') }}
                </v-btn>
            </div>
        </div>
        <div class="user-form-content-container">
            <div class="content-container table-permission-container">
                <v-data-table
                    :headers="headers"
                    :items="permissionItem"
                    hide-default-footer
                >
                    <template v-slot:[`item.view`]="{ item }">
                        <v-checkbox
                            :class="backgroundCheckBox(item.view)"
                            :ripple="false"
                            :value="item.view"
                            v-model="form.select_permission"
                        ></v-checkbox>
                    </template>
                    <template v-slot:[`item.update`]="{ item }">
                        <v-checkbox
                            :class="backgroundCheckBox(item.update)"
                            :ripple="false"
                            :value="item.update"
                            v-model="form.select_permission"
                            :disabled="isUpdateFieldDisabled(item.update, item.view)"
                        ></v-checkbox>
                    </template>
                </v-data-table>
            </div>
            <div class="staff-info-form">
                <v-card class="card-border">
                    <h1 class="card-header">
                        {{this.$vuetify.lang.t('$vuetify.employee.profile')}}
                    </h1>
                    <v-form
                        lazy-validation
                        v-model="valid"
                        ref="form">
                        <v-container>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        v-model="form.employee_id"
                                        autocomplete="off"
                                        :error-messages="errors.employee_id"
                                        :rules="usernameRules"
                                        required
                                    >
                                        <template #label>
                                            {{ trans.userForm.employeeId }}<span class="require-star">* </span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        v-model="form.phone_number"
                                        :prefix="`(${nationalTelCode})`"
                                        :rules="phoneRules"
                                        placeholder="00 000 0000"
                                        autocomplete="off"
                                        v-mask = "'## ### ####'"
                                        :error-messages="errors.phoneNumber"
                                    >
                                        <template #label>
                                            {{ trans.userForm.phoneNumber }}<span class="require-star">* </span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <!-- NAME TH -->
                            <v-row>
                                <v-col cols="6">
                                    <v-row>
                                        <!-- PREFIX TH -->
                                        <v-col cols="4" class="pr-0">
                                            <div :class="labelSelector">
                                                {{ trans.userForm.prefixThai }}
                                                <span class="require-star">* </span>
                                            </div>
                                            <v-select
                                                class="no-padding-selector"
                                                v-model="form.prefix_th"
                                                :items="prefixOptions.th"
                                                :error-messages="errors.prefix_th"
                                                :rules="prefixRules"
                                                :placeholder="this.$vuetify.lang.t('$vuetify.employee.prefixThai')"
                                                background-color="#ffffff"
                                                required dense filled
                                            ></v-select>
                                        </v-col>

                                        <!-- FIRST NAME TH -->
                                        <v-col cols="8">
                                            <v-text-field
                                                v-model="form.first_name_th"
                                                autocomplete="off"
                                                :error-messages="errors.first_name_th"
                                                :rules="usernameRules"
                                                required
                                            >
                                                <template #label>
                                                    {{ trans.userForm.firstNameThai }}<span class="require-star">* </span>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <!-- LAST NAME TH -->
                                <v-col cols="6">
                                    <v-text-field
                                        v-model="form.last_name_th"
                                        autocomplete="off"
                                        :error-messages="errors.last_name_th"
                                        :rules="usernameRules"
                                        required
                                    >
                                        <template #label>
                                            {{ trans.userForm.lastNameThai }}<span class="require-star">* </span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <!-- NAME EN -->
                            <v-row>
                                <v-col cols="6">
                                    <v-row>
                                        <!-- PREFIX EN -->
                                        <v-col cols="4" class="pr-0">
                                            <div :class="labelSelector">
                                                {{ trans.userForm.prefixEnglish }}
                                                <span class="require-star">* </span>
                                            </div>
                                            <v-select
                                                class="no-padding-selector"
                                                v-model="form.prefix_en"
                                                :items="prefixOptions.en"
                                                :error-messages="errors.prefix_en"
                                                :rules="prefixRules"
                                                :placeholder="trans.userForm.prefixEnglish"
                                                background-color="#ffffff"
                                                required dense filled
                                            ></v-select>
                                        </v-col>

                                        <!-- FIRST NAME EN -->
                                        <v-col cols="8">
                                            <v-text-field
                                                v-model="form.first_name_en"
                                                autocomplete="off"
                                                :error-messages="errors.first_name_en"
                                                :rules="usernameRules"
                                                required
                                            >
                                                <template #label>
                                                    {{ trans.userForm.firstNameEnglish }}<span class="require-star">* </span>
                                                </template>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <!-- LAST NAME EN -->
                                <v-col cols="6">
                                    <v-text-field
                                        v-model="form.last_name_en"
                                        autocomplete="off"
                                        :error-messages="errors.last_name_en"
                                        :rules="usernameRules"
                                        required
                                    >
                                        <template #label>
                                            {{ trans.userForm.lastNameEnglish }}<span class="require-star">* </span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        v-model="form.email"
                                        autocomplete="off"
                                        :error-messages="errors.email"
                                        :rules="emailRules"
                                        :disabled="operationMode === 'edit' ? true : false"
                                        required
                                    >
                                        <template #label>
                                            {{ trans.userForm.email }}<span class="require-star">* </span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field
                                        label="Username"
                                        v-model="form.username"
                                        autocomplete="off"
                                        :error-messages="errors.username"
                                        :rules="usernameRules"
                                        :disabled="operationMode === 'edit' ? true : false"
                                    >
                                        <template #label>
                                            {{ trans.userForm.username }}<span class="require-star">* </span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field
                                        v-if="operationMode === 'create'"
                                        :label="trans.userForm.password"
                                        v-model="form.password"
                                        autocomplete="off"
                                        :error-messages="errors.password"
                                        :rules="usernameRules"
                                        :append-icon="operationMode ==='create' ? 'mdi-content-copy': ''"
                                        @click:append="copyPassword()"
                                        readonly
                                    >
                                    </v-text-field>
                                    <v-text-field
                                        v-else-if="operationMode === 'edit'"
                                        v-model="form.password"
                                        :label="trans.userForm.password"
                                        disabled
                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
    name: 'UserForm',
    directives: {
        mask
    },

    data () {
        return {
            valid: true,
            userId: '',
            operationMode: '',
            form: {
                employee_id: null,
                phone_number: null,
                prefix_th: null,
                prefix_en: null,
                first_name_th: null,
                first_name_en: null,
                last_name_th: null,
                last_name_en: null,
                email: null,
                username: null,
                password: null,
                select_permission: []
            },
            prefixRules: [
                v => this.$validator.hasValue(v, this.trans.userForm.thisFieldIsRequired)
            ],

            usernameRules: [
                v => this.$validator.hasValue(v, this.trans.userForm.thisFieldIsRequired),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.userForm.thisFieldIsExceededCharacters),
                v => this.$validator.hasSomeCharacter(v, '#', this.trans.userForm.cannotHaveSharp)
            ],

            emailRules: [
                email => this.$validator.hasValue(email, this.trans.userForm.emailIsRequired),
                email => this.$validator.lengthNotExceed(email, 255, this.trans.userForm.emailIsExceededCharacters),
                email => this.$validator.correctFormat(email, /.+@.+\..+/, this.trans.userForm.invalidEmailFormat)
            ],
            phoneRules: [
                v => this.$validator.correctPhoneNumber(v, this.trans.userForm.incorrectPhoneNumber)
            ],
            nationalTelCode: '+66',
            errors: {},
            permissionItem: [],
            prefixOptions: { en: [], th: [] }
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.userForm.permissionType'), value: 'permissionName', width: '34%', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.userForm.view'), value: 'view', align: 'center', width: '33%', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.userForm.update'), value: 'update', align: 'center', width: '33%', sortable: false }
            ]
        },
        breadcrumbsItem () {
            return [
                {
                    text: this.trans.userForm.companySetting,
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'UserManagement'
                    }
                },
                {
                    text: this.operationMode === 'create' ? this.trans.userForm.createUserByAdmin : this.trans.userForm.editUserByAdmin,
                    disabled: true
                }
            ]
        },
        labelSelector () {
            return `label-selector lang-${this.$vuetify.lang.current}`
        }
    },

    methods: {
        backgroundCheckBox (value) {
            if (this.form.select_permission.includes(value)) {
                return 'background-selected-check-box'
            }
        },

        isUpdateFieldDisabled (updateValue, viewValue) {
            if (updateValue === null) {
                return true
            } else if (!this.form.select_permission.includes(viewValue)) {
                return true
            } else {
                return false
            }
        },

        copyPassword () {
            navigator.clipboard.writeText(this.form.password)
        },

        backToCompanyUserList () {
            this.$router.push({ name: 'UserManagement' }, () => {})
        },

        generatePassword () {
            const length = 18
            const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
            let passwordGen = ''
            for (var i = 0, n = charset.length; i < length; ++i) {
                passwordGen += charset.charAt(Math.floor(Math.random() * n))
            }
            this.form.password = passwordGen
        },

        resetForm () {
            this.errors = {}
            this.form = {
                employee_id: null,
                phone_number: null,
                prefix_th: null,
                prefix_en: null,
                first_name_th: null,
                first_name_en: null,
                last_name_th: null,
                last_name_en: null,
                email: null,
                username: null,
                password: null,
                select_permission: []
            }
        },

        handleResponse (res) {
            if (res && res.data) {
                if (res.data.status === 'ok') {
                    this.$store.dispatch('setLoading', false)
                    this.$notify({
                        title: this.trans.userForm.congratulations,
                        text: this.operationMode === 'create' ? this.trans.userForm.createUserByAdmin : this.trans.userForm.editUserByAdmin,
                        type: 'notify-success'
                    })

                    this.$router.push({ name: 'UserManagement' }, () => {})
                } else if (res.data.status === 'error_inputs') {
                    this.errors = res.data.errors
                    this.$store.dispatch('setLoading', false)
                    for (const property in this.errors) {
                        this.$notify({
                            title: this.trans.userForm.somethingWrong,
                            text: this.errors[property],
                            type: 'notify-error'
                        })
                    }
                }
            }
        },

        getFormData () {
            const form = JSON.parse(JSON.stringify(this.form))
            form.phone_number = `${this.nationalTelCode} ${this.form.phone_number}`

            if (this.operationMode !== 'create') {
                delete form.password
                delete form.username
                delete form.email
            }

            return form
        },

        async createUserByAdmin () {
            const res = await this.axios.post('user/create', this.getFormData())
            this.handleResponse(res)
        },

        async editUserByAdmin () {
            const res = await this.axios.put(`user/edit/${this.userId}`, this.getFormData())
            this.handleResponse(res)
        },

        async submit () {
            this.$refs.form.resetValidation()
            if (!this.$refs.form.validate()) {
                return
            }

            this.$store.dispatch('setLoading', true)
            if (this.operationMode === 'create') {
                await this.createUserByAdmin()
            } else {
                await this.editUserByAdmin()
            }
        },

        async getUser (userId) {
            const res = await this.axios.get(`user/get/${userId}`)
            if (res && res.data && res.data.status === 'ok') {
                const { data } = res.data
                this.form = data
                this.form.password = '********'
                this.form.phone_number = data.phone_number.substr(4)
            } else {
                this.backToCompanyUserList()
            }
        },

        async getPrefix () {
            const langs = ['th', 'en']
            const url = 'employee/prefix/options'
            for (let i = 0; i < langs.length; i++) {
                const lang = langs[i]
                const res = await this.axios.get(url + `?lang=${lang}`)
                if (res && res.data && res.data.status === 'ok') {
                    this.prefixOptions[lang] = res.data.data
                }
            }
        },

        async getPermissionList () {
            const res = await this.axios.get('user/permissions')
            if (res && res.data && res.data.status === 'ok') {
                const { data } = res.data
                this.form.select_permission = data.default
                this.permissionItem = data.permissionListForSelect
            }
        }
    },

    created () {
        this.registerLang({
            userForm: [
                'cancel', 'save', 'update', 'createUserByAdmin', 'editUserByAdmin', 'cannotHaveSharp', 'companySetting', 'congratulations',
                'employeeId', 'email', 'emailIsExceededCharacters', 'emailIsRequired', 'incorrectPhoneNumber', 'invalidEmailFormat',
                'prefixThai', 'prefixEnglish', 'firstNameThai', 'firstNameEnglish', 'lastNameThai', 'lastNameEnglish', 'view',
                'username', 'password', 'permissionType', 'profile', 'phoneNumber', 'somethingWrong',
                'thisFieldIsRequired', 'thisFieldIsExceededCharacters'
            ]
        })
    },

    async mounted () {
        this.userId = this.$route.params.id
        this.resetForm()
        await this.getPrefix()
        await this.getPermissionList()

        if (this.userId) {
            await this.getUser(this.userId)
            this.operationMode = 'edit'
        } else {
            this.operationMode = 'create'
            this.generatePassword()
        }
    },

    watch: {
        'form.select_permission': {
            handler: function (newVal, oldVal) {
                if (newVal.length < oldVal.length) {
                    let getUncheckValue = oldVal.filter(x => !newVal.includes(x))[0]
                    if (getUncheckValue.includes('VIEW')) {
                        getUncheckValue = getUncheckValue.replace('VIEW', 'UPDATE')
                        const indexOfUpdatePermission = newVal.indexOf(getUncheckValue)
                        if (indexOfUpdatePermission !== -1) {
                            newVal.splice(indexOfUpdatePermission, 1)
                        }
                    }
                }
            },
            deep: true
        },

        '$vuetify.lang.current': {
            handler: async function (after, before) {
                this.$utils.recheckValidate(this.$refs.form.inputs)
                await this.getPermissionList()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
}

.user-form-content-container {
    display: flex;
    justify-content: space-between;
}
.table-permission-container {
    width: calc(55% - 25px);
    height: fit-content;
}

.background-selected-check-box {
    background-color: #fdf6f3;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.staff-info-form {
    width: 45%;
    .card-border {
        padding: 36px 42px;
        border-radius: 15px;
    }
}

.card-header {
    font-size: 24px;
    font-weight: normal;
    color: #000;
    margin-bottom: 1rem;
}
::v-deep .theme--light.v-data-table {
    background-color: transparent;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
    & td:not(:first-child) {
        padding: 0 !important;
        .v-input__slot {
            justify-content: center;
        }
        .v-input--selection-controls {
            padding-top: 16px;
            margin-top: 0;
        }
    }
    & td {
        background-color: #fff;
    }

    & td:nth-child(2) {
        border-right: 1px solid #e0e0e0;
    }
}

.label-selector {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12.5px;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.lang-th {
        margin-top: 1px;
        margin-bottom: -10px;
        font-family: Prompt;
    }
    &.lang-en {
        margin-top: 1.5px;
        margin-bottom: -10px;
        font-family: LexendDeca;
    }
}

::v-deep .no-padding-selector {
    .v-input__slot {
        padding: 0px !important;
        background: none !important;
        min-height: 37.5px !important;
    }

    .v-select__selection {
        margin-bottom: 0px !important;
    }

    .v-text-field__details {
        padding: 0 !important;
    }
}

::v-deep .v-form .container {
    padding: 0;
}
::v-deep .breadcrumb-container .v-breadcrumbs {
    padding-bottom: 18px;
}
</style>
